import { DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { LabelTemplateClient } from '@frontend/label/api';
import { LabelQueryParams, LabelTemplate, LabelTemplateQueryParams } from '@frontend/label/types';
import React, { useState } from 'react';

const ID = 'label-template-select';
export const LabelTemplateSelect = (props: ObjectSelectProps<LabelTemplate, LabelQueryParams>) => {
    const [v, cV] = useState<LabelTemplate | null>(null);
    return (
        <ObjectSelectInput<LabelTemplate, DefaultQueryParams | LabelTemplateQueryParams>
            id={`${ID}${props.id && '-' + props.id}`}
            label='Label Template'
            helpMessage={props.helpMessage}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(props) => LabelTemplateClient.fetchLabelTemplates({ ...props })}
            itemLabel={(object) => object.name}
        />
    );
};
